import { createSelector } from 'reselect'
import modelComparisonResultDataIsPendingSelector from '../pending-request/modelComparisonResultDataIsPendingSelector'
import codeComparisonResultDataIsPendingSelector from '../pending-request/codeComparisonResultDataIsPendingSelector'
import comparisonCarlineStructureRequestIsPendingSelector from '../pending-request/comparisonCarlineStructureRequestIsPendingSelector'
import comparisonDataSelector from '../comparison/comparisonDataSelector'

const comparisonPageIsLoadingSelector = createSelector(
    modelComparisonResultDataIsPendingSelector,
    codeComparisonResultDataIsPendingSelector,
    comparisonCarlineStructureRequestIsPendingSelector,
    comparisonDataSelector,
    (modelsPending, codesPending, carlinePending, comparisonData) => {
        const isModelsTab = comparisonData?.type === 'models'
        return modelsPending || codesPending || (isModelsTab && carlinePending)
    },
)

export default comparisonPageIsLoadingSelector
